import { render, staticRenderFns } from "./TravelGroupList.vue?vue&type=template&id=0d514f32&scoped=true&"
import script from "./TravelGroupList.vue?vue&type=script&lang=js&"
export * from "./TravelGroupList.vue?vue&type=script&lang=js&"
import style0 from "./TravelGroupList.vue?vue&type=style&index=0&id=0d514f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d514f32",
  null
  
)

export default component.exports